module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p9-41c61be38f8e7395b32700b1e714b66b.png";